export default __webpack_public_path__ + "static/media/sqprofpic.533982d4.jpg";